export enum WishlistIconName {
  Empty = 'Empty',
  EmptyCompact = 'EmptyCompact',
}
